import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'
import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { refreshAccessToken } from '../../../utilities/extensions'

export default function DashboardDocumentsHeader() {
  const navigate = useNavigate()
  const [canDownloadUF, setCanDownloadUF] = useState(true)
  const [downloadingPDF, setDownloadingPDF] = useState(false)

  useEffect(() => {
    const handleDownloadUF = async () => {
      try {
        const newUrlResponse = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(customerData.customerDocuments.taxDocument2021UF)}`, {
          headers: {
            'Authorization': customerData.accessToken
          }
        })
        const newUrlData = await newUrlResponse.json()
        if (newUrlData.response.error) {
          if (newUrlData.response.error === 'Failed To Authenticate Token.') {
            const refreshedToken = await refreshAccessToken()
            refreshedToken && refreshedToken.length > 0 ? await handleDownloadUF() : navigate('/', { state: { expired: true } })
          } else
            console.error(newUrlData.response.error)
        } else {
          const downloadResponse = await fetch(newUrlData.response.s3Url)
          if (!downloadResponse.ok)
            setCanDownloadUF(false)
        }
      } catch (error) {
        //setCanDownloadUF(false)
      }
    }

    if (customerData.customerDocuments.taxDocument2021UF)
      handleDownloadUF()
    else
      setCanDownloadUF(false)
  }, [])

  const handleDownloadPDF = async (pdfURL) => {
    setDownloadingPDF(true)

    const addForm8888Response = await fetch(`${apiURL}/api/addForms?customerId=${customerData.customerLeadData.leadContact.contactId}&linkURL=${pdfURL}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const blob = await addForm8888Response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url;
    a.download = customerData.customerDocuments.taxDocument2021.split('/').pop()
    document.body.appendChild(a)
    a.click()
    a.remove()

    setDownloadingPDF(false)
  }

  const handleDownloadNewPDF = () => {
    if (canDownloadUF) {
      if (customerData.customerLeadData.leadStage.leadStageId === '04144458-31da-4f86-be7b-69051d6c1cc9') {
        const hasQRCode = customerData?.customerQRCodeData?.qrCodeURL
        const hasAdvanceFundingLabel = customerData?.customerShippoLabels?.some(label => label.labelType === 'Advance Funding' && label.trackingStatus !== 'DELIVERED')

        if (hasQRCode || hasAdvanceFundingLabel)
          navigate('/downloadDocument')
        else
          navigate('/readyCloud')
      } else
        navigate('/downloadDocument')
    } else
      handleDownloadPDF(customerData?.customerDocuments?.['taxDocument2021'])
  }

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      {downloadingPDF && (
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-white font-mont'>
          <div className='flex flex-row items-center justify-center gap-2'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4 mb-4'></div>
            <p>Downloading PDF...</p>
          </div>
        </div>
      )}
    </div>
  )
}

/**
 * {customerData.customerLeadData.leadStage.leadStageId === '3d261241-5b93-49df-95e6-6e8bfbc75f71' && (
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-6 mt-4'>
          <p className='font-bold text-2xl text-[#646464]'>Action Required: Update Your IRS Transcript Immediately</p>
          <p className='text-[#646464] text-lg text-left'>Click the button labeled "Connect with Chart" to Protect & Track Your Refund  This steps protects your identity and enables us to securely monitor your IRS tax transcript. By doing so, we can confirm that your refund is correctly processed and sent directly to you - either by check or ACH deposit into your bank account.</p>
          <p className='text-[#646464] text-lg text-left'>Your tax refund is never routed to us. It always goes directly to you.</p>
          <button onClick={() => navigate('/reauth-flow')} className='px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
            Connect with Chart
          </button>
          <p className='text-sm text-gray-400 mt-2 text-center'>Thank you for your prompt attention.</p>
        </div>
      )}
 */